import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import { motion } from "framer-motion";

const PostLink = ({ post }) => (
  <motion.div
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    className="relative group mb-8 bg-white py-8 px-6 rounded-xl shadow-sm"
  >
    <Link to={post.frontmatter.slug}>
      <Img fluid={post.frontmatter.featuredImage.childImageSharp.fluid} />
      <h3 className="font-bold text-black mt-6 mb-3">
        {post.frontmatter.title}
      </h3>
      <p className="text-black mb-6 overflow-hidden whitespace-nowrap text-ellipsis">
        {post.frontmatter.excerpt}
      </p>
      <div className="flex justify-center font-otomanopee tracking-widest items-center h-12 border-2 transition-all duration-150 rounded-full bg-white border-gold text-gold group-hover:bg-gold group-hover:border-gold-100 group-hover:text-white">
        もっと見る
      </div>
    </Link>
  </motion.div>
);
export default PostLink;
